"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItcExactMatch = void 0;
var _ItcConstants = require("./constants/ItcConstants");
var _domainSources = require("./constants/domainSources");
// eslint-disable-next-line complexity
const getItcExactMatch = ({
  isAftermarketPremium,
  isRegPremium,
  isAuction,
  isPreReg,
  showSmartExactMatchDomain,
  isAvailable,
  isNameBuilderCard,
  isSpinDomain,
  isTaken,
  domainSource,
  itc = ''
}) => {
  if (!_ItcConstants.AVAILABLE_FOR_GRANULAR_ITC.includes(itc) || isSpinDomain) {
    return itc;
  }
  const cardType = !domainSource || domainSource === _domainSources.DOMAIN_SOURCES.EXACT_MATCH ? 'ExactMatch' : 'Alternate';
  if (isNameBuilderCard) {
    return _ItcConstants.ITC[itc].NameBuilder;
  } else if (isAftermarketPremium) {
    return _ItcConstants.ITC[itc][cardType].Premium;
  } else if (isRegPremium) {
    return _ItcConstants.ITC[itc][cardType].RegPremium;
  } else if (isAuction) {
    return _ItcConstants.ITC[itc][cardType].Auction;
  } else if (isPreReg) {
    return _ItcConstants.ITC[itc].ExactMatch.PreReg;
  } else if (showSmartExactMatchDomain) {
    return _ItcConstants.ITC[itc].ExactMatch.SmartExactTLD;
  } else if (isAvailable) {
    return _ItcConstants.ITC[itc][cardType].Available;
  } else if (isTaken) {
    return _ItcConstants.ITC[itc][cardType].Taken;
  }
  return itc;
};
exports.getItcExactMatch = getItcExactMatch;